import { Component, OnInit } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { ApiService } from '../../shared/api.service';
import { EventSendeurService } from '../../shared/event-sendeur.service';
import { Router } from '@angular/router';
import {  LocalDataSource } from 'ng2-smart-table';
import { EditProjetComponent } from './edit-projet/edit-projet.component';
import { Projet } from '../../shared/data/projet';
import { plainToClass } from 'class-transformer';
import { PublishRenderComponent } from './publish-render.component';
import swal from 'sweetalert2';
import { Config } from '../../config/config';

@Component({
  selector: 'ngx-projet',
  templateUrl: './projet.component.html',
  styleUrls: ['./projet.component.scss']
})
export class ProjetComponent implements OnInit {

  // projets:Projet[] =[];

  config = Config;

  source: LocalDataSource =  new LocalDataSource();

   settings = {

    hideSubHeader: false,
    mode: 'external',
    actions: {
      columnTitle: '',
      position: 'left',
      add: true,
      edit: true,
      delete: true,
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      confirmCreate: false,
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
      confirmSave:false
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      id: {
        title: 'ID',
        type: 'number',
        filter: false,
      },
      urltmbPhoto: {
        title: 'Photo',
        type: 'html',
        valuePrepareFunction: (photo:string) => { return `<img  src="${photo}" height="50px" width="50px" />`; },
        filter: false
      },
      titre: {
        title: 'Titre',
        type: 'string',
      },
      is_publish: {
        title: '',
        type: 'custom',
        renderComponent: PublishRenderComponent, // ne pas oublier de déclarer dans le module et d'ajouter dans l'entré entryComponents
        filter: false,
      },
    
    },
    pager : {
      perPage :10
    },
 
};

constructor(private dialogService: NbDialogService,private apiService:ApiService, private sendeurService:EventSendeurService, private router:Router, private toastr:NbToastrService) { }

  ngOnInit() {
    this.getProjet();
    this.sendeurService.pageSendeur.subscribe(data =>{
      this.getProjet();
    })
  }

  select($event){
    this.dialogService.open(EditProjetComponent,{context:{id:$event.data.id}});
  }

  onDelete(event){
    // this.dialogService.open(DeleteProjetConfirmComponent,{context:{id:event.data.id}});
    /* this.articleEdit = event.data;
    this.dialogService.open(DeleteArticleComponent,{context: { id: event.data.id}}); */
    const proj = plainToClass( Projet,  event.data as object);
    
    swal({
      title: 'Suppression Projet',
      text: 'Voulez - vous vraiment supprimer ' + proj.titre + ' ? Vous ne pourrez plus annuler cet opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        // this.dialogIsNotShow = true;

        return this.apiService.deleteProjetProvider(proj.id).subscribe(data =>{
          
          // console.log(data);
          this.source.remove(event.data);
         
        },(err) =>{
          this.toastr.danger("Echec de suppréssion ");
          if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }
    
          if(err.error.code ===500){
          
            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
         }
        })

      },
    }).then((result) => {

      if (result.value) {


        this.toastr.success("Supprimé(e)", proj.titre);

      }

      // this.dialogIsNotShow = false;

    });

  
  }

  onCreate(event){
    this.dialogService.open(EditProjetComponent,{context:{id:0}});
  }

  getProjet(){
    this.apiService.getAllProjetProvider().subscribe(data =>{
      this.source.load(plainToClass( Projet, data));
      this.source.setSort([{ field: 'id', direction: 'desc' }]);

    },(err) =>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
    })
  }

}
